import React, { createContext, useContext } from 'react'
import Modal from 'react-modal'
import { css } from 'emotion'
import { z, borderRadius } from 'app/style'
import styled from 'react-emotion'
import Row, { RowSpacer } from '../components/Row'
import Button from '../components/Button'
import Icon from '../components/Icon'

const overlayClass = css({
  label: 'ModalOverlay',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: `rgba(0, 0, 0, 0.7)`,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  zIndex: z.modal
})

const ModalContext = createContext()

const WiipModal = styled(({ children, close, className, ...props }) => (
  <Modal
    isOpen
    onRequestClose={close}
    className={className}
    overlayClassName={overlayClass}
    contentLabel="Modal"
    {...props}
  >
    <ModalContext.Provider value={{ close }}>{children}</ModalContext.Provider>
  </Modal>
))(({ small }) => ({
  label: 'Modal',
  width: small ? 400 : 560,
  maxWidth: '96%',
  maxHeight: '76vh',
  marginTop: '12vh',
  background: 'white',
  borderRadius,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column',
  fontSize: 16
}))

export default WiipModal

export const ModalTitle = ({ children }) => {
  const { close } = useContext(ModalContext)
  return (
    <Row top xLarge>
      {children}
      <RowSpacer />
      <Button onClick={close}>
        <Icon icon="x" />
      </Button>
    </Row>
  )
}

export const asModal = ({ small, close }) => Component => ({
  onAfterOpen,
  ...props
}) => (
  <WiipModal
    small={small}
    close={close || props.close}
    onAfterOpen={onAfterOpen && onAfterOpen}
  >
    <Component {...props} />
  </WiipModal>
)
